import { AsyncStateNotification } from '../AsyncStateNotification';
import { coreActions } from '@sonar-software/sonar-core';
import { NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { useLinkTag } from '@hooks';

export interface BulkTagNotificationProps {
	autoReset?: boolean;
}

export const BulkTagNotification: React.FC<BulkTagNotificationProps> = ({ autoReset }) =>
	<AsyncStateNotification
		errored={ NOTIFICATIONS_COPY.ERROR_BULK_TAG }
		failed={ NOTIFICATIONS_COPY.FAILED_BULK_TAG }
		received={ NOTIFICATIONS_COPY.SUCCESS_BULK_TAG }
		resetRawAction={ autoReset ? coreActions.resetPostCoreTagsLink : undefined }
		stateSelector={ useLinkTag.selectors.state } />;

